
export const reviews = [
    {
        id: 1,
        name: "Keshav Kumar",
        date: "1 Weeks",
        image: "https://lh3.googleusercontent.com/a/ACg8ocLuY77t5n44NVFWcOYURK8LWpKzIIG6up0JJc1Lwu8d0laiUA=w90-h90-p-rp-mo-br100",
        rating: 5,
        review: "This is so nice 👍 the quality of items are very good. I am totally satisfied with this ❤️ …"
    },
    {
        id: 2,
        name: "Varinder rajput",
        date: "1 Month",
        image: "https://lh3.googleusercontent.com/a-/ALV-UjUwH0w8LV_xVwJwaCJ39XmrVtlutrWMTCk74tROGcLW-mJ18rarTA=w90-h90-p-rp-mo-br100",
        rating: 5,
        review: "Nice great good product at best price with quality"
    },
    {
        id: 3,
        name: "Ravin Chand",
        date: "2 Month",
        image: "https://lh3.googleusercontent.com/a/ACg8ocK1nGH_VYtWMXQEddzEeErnMEDOKhrVGrme10dUIBcURun0rg=w90-h90-p-rp-mo-br100",
        rating: 5,
        review: "One of the best Electronic Store in Gurgoan. The prices and staff is just excellent 👍🏻 …"
    },
    {
        id: 5,
        name: "Vikas Sharma",
        date: "2 Month",
        image: "https://lh3.googleusercontent.com/a/ACg8ocIR3FBfAFF4gp5z2kvbaZw3UbDsTIhNfpNQ-6XTUp_C8HQd8A=w45-h45-p-rp-mo-br100",
        rating: 5,
        review: "Nice product and good picture quality on better discount.."
    },
    {
        id: 6,
        name: "Kiran Kumar",
        date: "2 Month",
        image: "https://lh3.googleusercontent.com/a/ACg8ocLwTWXMwHrNGM1i30goYMWHIr06zGg7hF1syxC0MJ1Ne0nbKQ=w90-h90-p-rp-mo-ba2-br100",
        rating: 5,
        review: "Good  deal ashi electronic Gurugram"
    },
    {
        id: 7,
        name: "Anuj Verma",
        date: "5 Month",
        image: "https://lh3.googleusercontent.com/a-/ALV-UjUpMDZnaxmZui0CZlkASWPBRcNStAkgN-eC2Uc6tQ-cCP9XvuyO=w45-h45-p-rp-mo-br100",
        rating: 5,
        review: "Good staff and well behaviour"
    },
    {
        id: 8,
        name: "Avnish Chaubey",
        date: "a year ago",
        image: "https://lh3.googleusercontent.com/a/ACg8ocJBZ9DJi3AlkaLWeAGcNeSP22zb8uDDny91NXBVQW5a-LOiQQ=w45-h45-p-rp-mo-br100",
        rating: 5,
        review: `That's provides good service and good products`
    },
    {
        id: 9,
        name: "Karn Parashar",
        date: "a year ago",
        image: "https://lh3.googleusercontent.com/a-/ALV-UjXPMva4OjN_Y-ja1MfDOM6PePP5r__UO38RzpodTGwHLlUojupQ=w45-h45-p-rp-mo-br100",
        rating: 5,
        review: "This place is awesome..... Must visit Ashok bhai is so helpful and will guide you the product in your budget.. Must visit place... Pricing is so genuine 👍👍 …"
    },
    {
        id: 10,
        name: "Vivek Raj",
        date: "9 Month",
        image: "https://lh3.googleusercontent.com/a-/ALV-UjXePSKoQ-uHEb7IQ6IAoMsMqOPM5rWNmnG9bHb_eufSlGv88SY=w45-h45-p-rp-mo-br100",
        rating: 5,
        review: "Very good service and and really very appreciative great opportunity to get electronics from here 🤗 …"
    },
];

export const specials = {
    "topBrands": [
        {
            "name": "Mitsubishi",
            "url": "/store-product/brand/mitsubishi"
        },
        {
            "name": "Cruise",
            "url": "/store-product/brand/cruise"
        },
        {
            "name": "Samsung",
            "url": "/store-product/brand/samsung"
        },
        {
            "name": "LG",
            "url": "/store-product/brand/lg"
        },
        {
            "name": "Whirlpool",
            "url": "/store-product/brand/whirlpool"
        },
        {
            "name": "Daikin",
            "url": "/store-product/brand/daikin"
        },
        {
            "name": "Panasonic",
            "url": "/store-product/brand/panasonic"
        },
        {
            "name": "Haier",
            "url": "/store-product/brand/haier"
        },
        {
            "name": "Godrej",
            "url": "/store-product/brand/godrej"
        },
        {
            "name": "Morphy Richards",
            "url": "/store-product/brand/morphy-richards"
        },
        {
            "name": "Bajaj",
            "url": "/store-product/brand/bajaj"
        },
        {
            "name": "Sansui",
            "url": "/store-product/brand/sansui"
        },
        {
            "name": "Inalsa",
            "url": "/store-product/brand/inalsa"
        },
        {
            "name": "Ifb",
            "url": "/store-product/brand/ifb"
        },
        {
            "name": "Prestige",
            "url": "/store-product/brand/prestige"
        },
        {
            "name": "Orient Electric",
            "url": "/store-product/brand/orient-electric"
        },
        {
            "name": "Faber",
            "url": "/store-product/brand/faber"
        },
        {
            "name": "Elica",
            "url": "/store-product/brand/elica"
        },
        {
            "name": "ROCKWELL",
            "url": "/store-product/brand/rockwell"
        },
        {
            "name": "YIQ",
            "url": "/store-product/brand/yiq"
        },
    ],

    "mainHeading": `Ashi Electronics: Buy Open Box Home Appliances & Electronics
`,

    "mainHeadingDescription": `Ashi Electronics is your trusted source for amazing deals on open-box, refurbished, and factory aged home appliances and electronics in Gurugram. We offer a wide selection of top brands like Samsung, LG, Whirlpool, and more, all at unbeatable prices. Whether you're looking for a new TV, washing machine, refrigerator, or the latest kitchen & home appliances, you'll find it at Ashi Electronics. <br /> Visit our store on MG Road, Sukhrali, Gurugram Outlet or browse our online catalog to discover incredible savings and give your home an upgrade without breaking the bank.`,

    "subHeading": `Get top-brand appliances and electronics at unbeatable prices.`,

    "subHeadingImpPoints": [
        {
            "heading": "Save Big:",
            "description": "Unbeatable deals on open-box and refurbished products."
        },
        {
            "heading": "Quality Assured:",
            "description": "All items rigorously tested and backed by warranty."
        },
        {
            "heading": "Top Brands:",
            "description": "Samsung, LG, Whirlpool, and more!"
        },
        {
            "heading": "Shop Your Way:",
            "description": "Visit our Gurugram store or buy online with easy delivery."
        }
    ]
}